import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import { getHolderList, getWidgetDTOList } from "../../Store/WidgetDataSelector";
import Workflow from "./Workflow";
import {find,isEmpty} from "lodash";
 
import { getApplicationDTO } from "../../Store/WidgetDataSelector";

function Holder(props) {
  const applicationContext = useContext(KycApplicationContext);
  const applicationDTO = useSelector((state) =>
     getApplicationDTO(state)
  );
  // maintain the current Holder object
  const [currentHolder, setCurrentHolder] = useState({});
  let HolderList = useSelector((state) =>
  getHolderList(state)
);

let widgetList = useSelector((state) =>
getWidgetDTOList(
  state,
  currentHolder ? currentHolder.entityTypeShortName : ""
)
);

  const isActive =(entityTypeShortName)=>{
    // classes should in snake Case
    if(applicationDTO.kycAccountTypeShortName !== "JA" ) {
      return ' holdersbtn '+((currentHolder && entityTypeShortName === currentHolder.entityTypeShortName) ?'SH_active': false) ;
    } else {
      return ' holdersbtn '+((currentHolder && entityTypeShortName === currentHolder.entityTypeShortName) ?'JH_active':
      ((entityTypeShortName == 'FH') ? 'JH_defaultFH' : 'JH_defaultSH'));
    }
   
  }

  // assign user selected workflow
  const assignHolder = (e, obj) => {
    e.preventDefault();
    //setCurrentHolder(obj);
    //applicationContext.setCurrentHolder(obj);
    props.onHolderChange(obj,widgetList);
  };

  useEffect(() => {
    //select the default workflow on render
    if (HolderList && HolderList.length > 0) {
     applicationContext.setCurrentHolder(getDefaultHolder(HolderList));
    }
    
  }, [HolderList]);

  function getDefaultHolder(holderList) {

    if(isEmpty(holderList)){
      //if the holder list is empty then return empty
      return null;
    }else{
      //if move to holder not defined then move to first holder object
      // other wise return matched with move to holder object
      if(isEmpty(applicationContext.moveToHolder)){
        return holderList[0];
      }else{
        var holder = find(holderList,(holder)=> holder.entityTypeShortName===applicationContext.moveToHolder);      
        applicationContext.setMoveToHolder("");
        return holder;
        }
      }
    }
  

  useEffect(() => {
    //select the default workflow on render
    setCurrentHolder(applicationContext.currentHolder);
  }, [applicationContext.currentHolder]);


  return (
    <div>
      {/* Loop the workflow list and create workflow button for each */}
      <div className="holders">
        {HolderList && HolderList.map((obj,index) => {
          return (
             
              <button className={isActive(obj.entityTypeShortName)}
                key={index}
                onClick={(event) => assignHolder(event, obj)}
              >
               {(currentHolder && obj.entityTypeShortName === currentHolder.entityTypeShortName) ? <span className="holderActiveIcon">   </span>  : <span className="holderInactiveIcon">   </span> }
                {obj.entityTypeName}
              </button>
            
          );
        })}
      </div>
      {/* Loop the current workflow widget and print it */}
      <div className="workFlow">
      {currentHolder && Array.isArray(currentHolder.kycApplicationWorkflowDTOList)  && currentHolder.kycApplicationWorkflowDTOList.length > 0 && (
          <>
          <p className="journal_type">Journey Type</p>
          <Workflow model={currentHolder.kycApplicationWorkflowDTOList} selectedWorkflow={currentHolder.selectedWorkflowDisplayName} holder={currentHolder.entityTypeShortName} 
          onWidgetChange={props.onWidgetChange}></Workflow></>
        )}
      </div>
    </div>
  );
}

export default Holder;
